module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Dagsmål","steak":"{count} day streak","streak":"{count}-dagers streak"},"en":{"title":"Daily Goal","steak":"{count} day streak"}}')
  delete Component.options._Ctor
}
